import React, { useState } from "react";
import { Link } from "react-router-dom";
import Contimg01 from '../../assets/images/OLD2.png';

const Contact = () => {
    const [formData, setFormData] = useState({
        fullName: '',
        phone: '',
        email: '',
        serviceType: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);

    // Form handling
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.fullName.trim()) {
            newErrors.fullName = 'Full Name is required';
        }
        
        if (!formData.email.trim()) {
            newErrors.email = 'Email Address is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }
        
        if (!formData.serviceType.trim() || formData.serviceType === 'Service type') {
            newErrors.serviceType = 'Please select a service type';
        }
        
        if (!formData.message.trim()) {
            newErrors.message = 'Message is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);

        try {
            // Send to your PHP backend
            const response = await fetch('https://thenriadvisors.com/api/send-email.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    fullName: formData.fullName,
                    email: formData.email,
                    phone: formData.phone || 'Not provided',
                    country: 'Not specified',
                    helpDescription: `Service Type: ${formData.serviceType}\n\nMessage: ${formData.message}`,
                    contactMethod: 'Email',
                    bestTime: 'Anytime'
                })
            });

            const result = await response.json();

            if (result.success) {
                setSubmitSuccess(true);
                setFormData({
                    fullName: '',
                    phone: '',
                    email: '',
                    serviceType: '',
                    message: ''
                });
                setErrors({});

                // Reset success message after 5 seconds
                setTimeout(() => {
                    setSubmitSuccess(false);
                }, 5000);
            } else {
                setErrors({ submit: result.message || 'Failed to send message. Please try again.' });
            }

        } catch (error) {
            console.error('Error sending email:', error);
            setErrors({ submit: 'Failed to send message. Please try again.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className="contact-form">
                <div className="container">
                    <div className="row gutter-y-30">
                        <div className="col-lg-8">
                            <div className="contact-form-inner">
                                {submitSuccess ? (
                                    <div style={{ 
                                        background: "#d4edda", 
                                        color: "#155724", 
                                        padding: "30px", 
                                        borderRadius: "8px", 
                                        textAlign: "center",
                                        marginBottom: "30px"
                                    }}>
                                        <i className="fas fa-check-circle" style={{ fontSize: "48px", marginBottom: "20px" }}></i>
                                        <h4 style={{ marginBottom: "15px" }}>Thank you for contacting us!</h4>
                                        <p style={{ marginBottom: "0" }}>We've received your message and will get back to you within 24-48 hours.</p>
                                    </div>
                                ) : (
                                    <form onSubmit={handleSubmit}>
                                        <div className="inquiry-form-group-one">
                                            <label>
                                                <i className="fa-regular fa-user" />
                                            </label>
                                            <input
                                                type="text"
                                                name="fullName"
                                                className="form-control"
                                                placeholder="Your Name"
                                                value={formData.fullName}
                                                onChange={handleInputChange}
                                                required
                                                style={{ 
                                                    borderColor: errors.fullName ? "#dc3545" : "" 
                                                }}
                                            />
                                            {errors.fullName && <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>{errors.fullName}</div>}
                                        </div>
                                        <div className="inquiry-form-group-one">
                                            <label>
                                                <i className="fa-solid fa-phone" />
                                            </label>
                                            <input
                                                type="tel"
                                                name="phone"
                                                className="form-control"
                                                placeholder="Your Mobile Number"
                                                value={formData.phone}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="inquiry-form-group-one">
                                            <label>
                                                <i className="fa-regular fa-envelope" />
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                className="form-control"
                                                placeholder="Your Email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                required
                                                style={{ 
                                                    borderColor: errors.email ? "#dc3545" : "" 
                                                }}
                                            />
                                            {errors.email && <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>{errors.email}</div>}
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                <i className="fa-solid fa-layer-group" />
                                            </label>
                                            <select 
                                                name="serviceType" 
                                                className="loan-type" 
                                                style={{
                                                    backgroundColor: "#f6f6f6",
                                                    borderColor: errors.serviceType ? "#dc3545" : ""
                                                }}
                                                value={formData.serviceType}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">Service type</option>
                                                <option value="Execution of Wills" style={{backgroundColor: "#f6f6f6"}}>Execution of Wills</option>
                                                <option value="Real Estate Management">Real Estate Management</option>
                                                <option value="Documentation">Documentation</option>
                                                <option value="Legal">Legal</option>
                                                <option value="Tours & Travel">Tours & Travel</option>
                                                <option value="Taxation">Taxations</option>
                                                {/* <option value="Medical Services">Medical Services</option> */}
                                                <option value="Finance and Accountancy">Finance and Accountancy</option>
                                                {/* <option value="Immigration">Immigration</option> */}
                                                <option value="Events & Entertainment">Events & Entertainment</option>
                                                <option value="Security">Security</option>
                                            </select>
                                            {errors.serviceType && <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>{errors.serviceType}</div>}
                                        </div>
                                        <div className="inquiry-form-group-one">
                                            <label>
                                                <i className="fa-solid fa-message" />
                                            </label>
                                            <textarea
                                                name="message"
                                                rows={4}
                                                className="form-control"
                                                placeholder="Your Message Here"
                                                value={formData.message}
                                                onChange={handleInputChange}
                                                required
                                                style={{ 
                                                    borderColor: errors.message ? "#dc3545" : "" 
                                                }}
                                            />
                                            {errors.message && <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "5px" }}>{errors.message}</div>}
                                        </div>
                                        
                                        {errors.submit && (
                                            <div style={{ 
                                                color: "#dc3545", 
                                                background: "#f8d7da", 
                                                padding: "15px", 
                                                borderRadius: "4px", 
                                                marginBottom: "20px",
                                                textAlign: "center"
                                            }}>
                                                {errors.submit}
                                            </div>
                                        )}
                                        
                                        <div className="form-group">
                                            <button 
                                                type="submit" 
                                                className="btn btn-outline-secondary"
                                                disabled={isSubmitting}
                                                style={{ minWidth: "150px" }}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <i className="fas fa-spinner fa-spin" style={{ marginRight: "8px" }}></i>
                                                        Sending...
                                                    </>
                                                ) : (
                                                    <>
                                                        Get a Quote <i className="flaticon-next" />
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="contact-form-right">
                                <h4>Say Hii to The NRI Advisors👋</h4>
                                <img src={Contimg01} alt="Contact-img" />
                                <div className="contact-details">
                                    <p>
                                    Our team at The NRI Advisors is here to help! Whether you're seeking guidance on investment opportunities, property management, taxation, or documentation support, we're committed to providing trusted, personalized assistance every step of the way.
                                    </p>
                                    
                                </div>
                                {/* <h4>Social media</h4>
                                <ul className="contact-social-media">
                                    <li>
                                        <Link to="https://www.facebook.com/">
                                            <i className="fa-brands fa-facebook-f" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://x.com/">
                                            <i className="fa-brands fa-twitter" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.instagram.com/">
                                            <i className="fa-brands fa-instagram" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://in.linkedin.com/">
                                            <i className="fa-brands fa-linkedin-in" />
                                        </Link>
                                    </li>
                                </ul> */}
                                  <button type="submit" className="btn btn-primary col-lg-7 ">
                                            Contact Us <i className="flaticon-next" />
                                        </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default Contact;